import { IMDMUnitField, IMdmUnitInstanceValue } from '@/pages/MDM/mdm.types.ts'
import usePrimitive from '@/pages/MDM/hooks/usePrimitive.ts'

interface IProps {
  field: IMDMUnitField
  value: IMdmUnitInstanceValue
}

const UnitInstanceValue = (props: IProps) => {
  const primitive = usePrimitive(props.field.typeEnumId)

  if (props.field.type === 'ENUM') {
    return <p className="text-nm">{primitive.values.find((v) => v.id === props.value.enumValueId)?.name || '-'}</p>
  }

  return <p className="text-nm">{props.value.value}</p>
}

export default UnitInstanceValue
